import { render, staticRenderFns } from "./userData.vue?vue&type=template&id=38b90e40&scoped=true&"
import script from "./userData.vue?vue&type=script&lang=js&"
export * from "./userData.vue?vue&type=script&lang=js&"
import style0 from "./userData.vue?vue&type=style&index=0&id=38b90e40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b90e40",
  null
  
)

export default component.exports